import { configureStore } from '@reduxjs/toolkit'
import { Provider } from 'react-redux';
import { authAPI, usersAPI, locationsAPI, facilitiesAPI, assetsAndLinksAPI } from './services';
import { authReducer, backdropReducer, dialogReducer, drawerReducer, utilsReducer } from './slices';

const ReduxStore = configureStore({
    reducer: {
        [authAPI.reducerPath]: authAPI.reducer,
        [usersAPI.reducerPath]: usersAPI.reducer,
        [locationsAPI.reducerPath]: locationsAPI.reducer,
        [facilitiesAPI.reducerPath]: facilitiesAPI.reducer,
        [assetsAndLinksAPI.reducerPath]: assetsAndLinksAPI.reducer,
        auth: authReducer,
        backdrop: backdropReducer,
        dialog: dialogReducer,
        utils: utilsReducer,
        drawer: drawerReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authAPI.middleware, usersAPI.middleware, facilitiesAPI.middleware, assetsAndLinksAPI.middleware),
});

export const AppRedux = ({ children }) => {
    return <Provider store={ReduxStore}>{children}</Provider>
}